import React from "react";
import styles from "./Checkbox.module.css";

function Checkbox(props) {
  return (
    <label className={styles.checkboxWrapper}>
      <input id={props.id} disabled={props.disabled} checked={props.checked} type={'checkbox'} className={styles.checkbox} placeholder={props.placeholder} onChange={props.onChange} />
      {props.label}
    </label>
  );
}

export default Checkbox;